import pages from "./en-US/pages";
import tip from "@/locales/en-US/tip";
export default {
  "batch.add.tips": "Errors detected",
  ...pages,
  ...tip,
};
